import { useEffect, useState } from 'react';
import { api, type Status } from './api';

export const fmtUsd = (n: number) =>
  new Intl.NumberFormat('fr-CH', { style: 'currency', currency: 'USD', maximumFractionDigits: n < 1 ? 3 : 2 }).format(n);

/**
 * Statut IA/budget, sondé discrètement (60 s). Partagé par la bannière d'alerte
 * globale et la roue dentée (solde + pastille d'avertissement).
 */
export function useStatus(): Status | null {
  const [status, setStatus] = useState<Status | null>(null);
  useEffect(() => {
    let alive = true;
    const load = () => api.status().then((s) => alive && setStatus(s)).catch(() => {});
    load();
    const id = setInterval(load, 60_000);
    return () => {
      alive = false;
      clearInterval(id);
    };
  }, []);
  return status;
}
